// extracted by mini-css-extract-plugin
module.exports = {"testingBanner":"TestingBanner_testingBanner__2mreP"};